/**
 * Application configuration constants
 */

/**
 * International location_id constant
 * Use this instead of hardcoding '0' throughout the codebase
 */
export const INTERNATIONAL_LOCATION_ID = '0';

/**
 * Orphan sentinel UUID - used for publications without a real author.
 * Hide author info in cards when authorId matches this value.
 */
export const ORPHAN_SENTINEL_UUID = '00000000-0000-0000-0000-000000000000';

export const APP_CONFIG = {
  name: 'Tax.Network',
  version: '1.0.0',
  description: 'Global network of tax experts',
  
  // Contact
  supportEmail: 'support@tax.network',
  contactEmail: 'contact@tax.network',
  
  // Pagination
  pagination: {
    defaullPagesize: 10,
    maxPageSize: 100,
    expertsPerPage: 12,
    publicationsPerPage: 12,
  },
  
  // File uploads
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  allowedDocumentTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  
  // Features
  features: {
    enableAnalytics: true,
    enableSocialSharing: true,
    enableNotifications: true,
  },
  
  // API
  api: {
    timeout: 30000, // 30 seconds
    retries: 3,
  },
  
  // External Links
  links: {
    githubRepoUrl: 'https://github.com/tax-network/tax.network-v2-8947ec3c',
  },
  
  // Live GitHub Actions workflows exposed to application controls.
  workflows: {
    localizationUiPrSync: 'loc-pr-sync.yml',
    localizationCodebaseSync: 'i18n-codebase-sync.yml',
    localizationHealthWeekly: 'localization-health-weekly.yml',
    localizationWeeklyReport: 'localization-weekly-report.yml',
    batchLedgerReconcile: 'batch-ledger-reconcile.yml',
    deployEdgeFunctions: 'deploy-edge-functions.yml',
  },
} as const;

export type AppConfig = typeof APP_CONFIG;

/**
 * Source of truth: route sourceIds that trigger focused layout (no nav menu, no footer).
 * Used by Header.tsx and PublicLayoutWrapper.tsx.
 */
export const FOCUSED_LAYOUT_SOURCE_IDS = new Set(['plans', 'checkout', 'auth']);
